export default defineAppConfig({
  ui: {
    input: {
      defaultVariants: {
        size: 'xl',
        variant: 'outline',
      }
    },
    inputMenu: {
      defaultVariants: {
        size: 'xl',
        variant: 'outline',
      }
    },
    selectMenu: {
      defaultVariants: {
        size: 'xl',
        variant: 'outline',
      }
    },
    card: {
      defaultVariants: {
        variant: 'outline',
      }
    },
    button: {
      defaultVariants: {
        size: 'xl',
      }
    },
    radioGroup: {
      defaultVariants: {
        size: 'xl',
      }
    },
    formField: {
      defaultVariants: {
        size: 'xl',
      }
    },
    colors: {
      primary: 'violet',
      neutral: 'gray'
    }
  }
})